import './skip_link.less';
 
import $ from 'jquery';
import React from 'react';

import first from 'lodash/first';
import { focusable } from 'tabbable';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

// historically this was not a feature and we didn't have a way to determine
// the main content. Because of this shortcoming we don't display this on older
// viewer versions
const SkipLink_ViewerVersion1 = ()=> null;

const SkipLink_ViewerVersion2 = ({ href, focusTarget })=> (
  <a
    href={href}
    className="zf-skip-link button-style"
    onClick={()=> {
      const focusEl = $(focusTarget).get(0);
      const focusableElements = focusable(focusEl);

      $(first(focusableElements)).focus();
    }}
  >
    Skip to main content
  </a>
);

const SkipLink = (props)=> (
  <SiteViewerVersionComponentSelector>
    <SkipLink_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <SkipLink_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default SkipLink;
